import React from 'react';
import { FormattedMessage } from 'react-intl';

import { styled } from '@styles';

import { Button } from '@components/atoms/Button';

import { commonMessages } from '@temp/intl';
import cartIcon from 'images/cart_white.svg';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 10px;
  & > img {
    height: 19px;
  }
`;

export interface IAddToCartButton {
  disabled: boolean;
  onSubmit: () => void;
  price: JSX.Element;
}

export const AddToCartButton: React.FC<IAddToCartButton> = ({
  onSubmit,
  disabled,
  price,
}) => (
  <Button
    fullWidth
    onClick={onSubmit}
    size="sm"
    color="primary"
    disabled={disabled}
  >
    <Wrapper>
      {price}
      <span>|</span>
      <FormattedMessage {...commonMessages.addToCart} />
      <img src={cartIcon} alt="cart icon" />
    </Wrapper>
  </Button>
);
AddToCartButton.displayName = 'AddToCartButton';
